export const STICKER_HANDLE_SIZE = 15;
export const ROTATION_HANDLE_RADIUS = 7;
export const ROTATION_HANDLE_OFFSET = 20;
export const PHOTOBOT_VERSION = 2.6;

// Helper function to check if mouse is over a sticker's resize handle
export const isOverResizeHandle = (sticker, mouseX, mouseY) => {
    const stickerWidth = sticker.img.width * sticker.scale;
    const stickerHeight = sticker.img.height * sticker.scale;
    return (
        mouseX > sticker.x + stickerWidth - STICKER_HANDLE_SIZE &&
        mouseX < sticker.x + stickerWidth &&
        mouseY > sticker.y + stickerHeight - STICKER_HANDLE_SIZE &&
        mouseY < sticker.y + stickerHeight
    );
};

// Helper function to check if mouse is over a sticker's main body
export const isOverSticker = (sticker, mouseX, mouseY) => {
    const stickerWidth = sticker.img.width * sticker.scale;
    const stickerHeight = sticker.img.height * sticker.scale;
    return (
        mouseX > sticker.x &&
        mouseX < sticker.x + stickerWidth &&
        mouseY > sticker.y &&
        mouseY < sticker.y + stickerHeight
    );
};

export const isOverRotationHandle = (sticker, mouseX, mouseY) => {
    const { img, scale, x, y, rotation = 0 } = sticker;

    const width = img.width * scale;
    const height = img.height * scale;

    // Sticker center
    const centerX = x + width / 2;
    const centerY = y + height / 2;

    // Offset to top-right corner, then move up by ROTATION_HANDLE_OFFSET
    const handleLocalX = width / 2;
    const handleLocalY = -height / 2 - 5;

    // Convert rotation degrees to radians
    const rad = (rotation * Math.PI) / 180;

    // Rotate handle position around center
    const handleRotatedX = centerX + (handleLocalX * Math.cos(rad)) - (handleLocalY * Math.sin(rad));
    const handleRotatedY = centerY + (handleLocalX * Math.sin(rad)) + (handleLocalY * Math.cos(rad));

    const dx = mouseX - handleRotatedX;
    const dy = mouseY - handleRotatedY;

    return Math.sqrt(dx * dx + dy * dy) <= ROTATION_HANDLE_RADIUS;
}